<template>
	<div class="order-detail-body" style="background:#fff;width:100%">
		<!-- <div class="shop-position">
			<img src="~/images/icon/position-icon.png" alt="">
			当前卖家店铺：<span style="color: #64B0FF"> {{ shopName }}</span>
		</div> -->
		<div class="order-detail-header">
			<div>
				<img src="~/images/icon/position.png" alt="" class="position">
				<div class="my-position">您的位置：</div>
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item>
						<span class="go-back-span" @click="goBack('all')">全部订单</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item>
						<span class="go-back-span" @click="goBack('single')">{{orderStatus}}</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item>订单详情</el-breadcrumb-item>
				</el-breadcrumb>
				<img src="~/images/icon//additional-order-icon.png" v-if="afterbillflag">
			</div>
			<div style="display: flex;align-items: center;">
				<div v-if="preFlag === 1">
					<img style="margin-left: 70px;" src="~/images/icon/preSale.png">
				</div>
				<el-button class="btn" size="small" plain type="primary" v-if="!canEdit" @click="exportExcel">导出</el-button>
				<el-button class="btn" size="small" plain type="primary" v-if="!canEdit" @click="printerEvent">打印</el-button>
			</div>
		</div>
		<div class="order-detail-info">
			<div class="info-left">
				<div class="info-left-container">
					<DetailInfo
						:detailData="detailData"
						:editBool="editBool"
						:editAuthority="editAuthority"
						:AuthorityList="AuthorityList"
						:matchbillcenterflag='matchbillcenterflag'
						:cancelState='cancelstate'
						:reason='reason'
						:canDirectSendflag='canDirectSendflag'
						:orderTakingModel='orderTakingModel'
						:confirmOrder="confirmOrder"
						:sellConfirmOrder="sellConfirmOrder"
						:deleveryType="deleveryType"
						@reload='reload'
						@arriveDateChange="arriveDateChange"
						@orderTakingModel2="orderTakingModel2"
					/>
					<OrderDetail
						:AuthorityList="AuthorityList"
						:detailData="detailData"
						:orderStatus="orderStatus"
						:orderNumberRoundRules='orderNumberRoundRules'
						:orderdecimalcount='orderdecimalcount'
						:canEdit='canEdit'
						:matchbillcenterflag='matchbillcenterflag'
						@deleteNew="deleteNew"
						@handleClick="handleClick"
						ref="infoRef"
					/>
					<!-- <GoodsInfo
						:notActivityFlag='notActivityFlag'
						:detailData="detailData"
						:goodsItemParams="goodsItemParams"
						:goodsSendParams="goodsSendParams"
						:editBool="editBool"
						:payType="payType"
						:payflag="payflag"
						:saveFlag.sync="saveFlag"
						:sellerEditFlag="sellerEditFlag"
						:AuthorityList="AuthorityList"
						:matchbillcenterflag='matchbillcenterflag'
						@priceChange="priceChange"
						@sendCounChange="sendCounChange"
						@deleteNew="deleteNew"
						ref="infoRef"
					/>
					<PaymentInfo
						:detailData="detailData"
						:editBool="editBool"
						@freightChange="freightChange"
						:payflag="payflag"
					/> -->
				</div>
				<div class="info-btn">
					<!-- <el-button class="btn" size="small" plain type="primary" v-if="orderStatus === '待发货' && cancelstate && AuthorityList['07_0001_0009_00']" @click="agreenRefuseCancel(true)">同意取消</el-button> -->
					<!-- <el-button class="btn" size="small" plain type="primary" v-if="orderStatus === '待发货' && cancelstate && AuthorityList['07_0001_0009_00']" @click="refuseOrder('cancel')">拒绝取消</el-button> -->
					<!-- <el-button class="btn" size="small" plain type="primary" v-if="orderStatus === '待发货' && AuthorityList['07_0001_0009_00'] && chlidflag === 0 && !cancelstate" @click="updateStatus(3)">全部发货</el-button> -->
					<!-- <el-button class="btn" size="small" plain type="primary" v-if="orderStatus === '待发货' && matchbillcenterflag === 0 && !cancelstate" @click="goDeliverManage">发货管理</el-button> -->
					<!-- <el-button class="btn" size="small" plain type="primary" v-if="(orderStatus === '待发货' || orderStatus === '待收货' || orderStatus === '已完成') && matchbillcenterflag === 0 && !cancelstate" @click="goDeliverHistory">历史发货记录</el-button> -->
					<!-- <el-button class="btn" size="small" plain type="primary" v-if="orderStatus === '待接单' && AuthorityList['07_0001_0006_00']" @click="refuseOrder('take')">拒单</el-button> -->
					<!-- <el-button class="btn" size="small" plain type="primary" v-if="orderStatus === '待接单' && AuthorityList['07_0001_0006_00']" @click="confirmOrAccept(2)">接单</el-button> -->
					<!-- <el-button class="btn" size="small" plain type="primary" v-if="orderStatus !== '已完成' && orderStatus !== '已取消' && editBool && ((orderStatus === '待付款' && payflag === 1) || (orderStatus === '待接单' && payType === '线下支付'))" @click="saveInfo(1)">保存</el-button> -->
					<!-- <el-button class="btn" size="small" plain type="primary" v-if="((orderStatus === '待付款' && payflag === 1) || (orderStatus === '待接单' && payType === '线下支付')) && (AuthorityList['07_0001_0003_00'] || AuthorityList['07_0001_0006_00'])" @click="editGoods">编辑商品</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="((orderStatus === '待付款' && payflag === 1) || (orderStatus === '待接单' && payType === '线下支付')) && (AuthorityList['07_0001_0003_00'] || AuthorityList['07_0001_0006_00'])" @click="addGoodsEvent">添加商品</el-button> -->
					<!-- <el-button class="btn" size="small" plain type="primary" v-if="(orderStatus === '待付款' && payflag === 1) && AuthorityList['07_0001_0003_00']" @click="goPay">买家去支付</el-button> -->
					<el-button v-if="payForCustomerFlag === 1 && showPayFlag" class="btn" size="small" plain type="primary" @click='payClick'>支付</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="!canEdit && sellerEditFlag ===1 && AuthorityList['07_0001_0015_00']" @click='sendEditClick'>编辑实收数</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="(!canEdit && orderStatus === '待付款' && AuthorityList['07_0001_0003_00']) || (!canEdit && orderStatus === '待接单' && AuthorityList['07_0001_0006_00']) || (!canEdit && orderStatus === '待发货' && AuthorityList['07_0001_0009_00'])" @click="editGoods">编辑商品</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="((!canEdit && orderStatus === '待付款' && AuthorityList['07_0001_0003_00']) || (!canEdit && orderStatus === '待接单' && AuthorityList['07_0001_0006_00']) || (!canEdit && orderStatus === '待发货' && AuthorityList['07_0001_0009_00'])) && preFlag !== 1" @click="addGoodsEvent">添加商品</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="!canEdit && AuthorityList['07_0001_0006_00'] && orderStatus === '待接单' && !lockFlag" @click="lockOrder('/lock')">锁定</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="!canEdit && AuthorityList['07_0001_0006_00'] && orderStatus === '待接单' && lockFlag" @click="lockOrder('/unlock')">解锁</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="!canEdit && payflag === 1 && AuthorityList['07_0001_0003_00'] && orderStatus === '待付款'" @click="goPay">买家去支付</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="!canEdit && confirmOrder === 1 && sellConfirmOrder === 1 && AuthorityList['07_0001_0006_00'] && orderStatus === '待接单' && canDirectSendflag" @click="errorMsgClick('send')">立即接单</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="!canEdit && confirmOrder === 1 && sellConfirmOrder === 1 && AuthorityList['07_0001_0006_00'] && orderStatus === '待接单' && !canDirectSendflag" @click="goCheck">买家去确认</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="!canEdit && (orderStatus === '待发货' || orderStatus === '待收货' || orderStatus === '已完成') && matchbillcenterflag === 0 && !cancelstate" @click="goDeliverHistory">历史发货记录</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="!canEdit && orderStatus === '待发货' && matchbillcenterflag === 0 && !cancelstate && AuthorityList['07_0001_0008_00']" @click="goDeliverManage">发货管理</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="!canEdit && orderStatus === '待发货' && AuthorityList['07_0001_0009_00'] && chlidflag === 0 && !cancelstate && cancelCause !== 1" @click="openSend">全部发货</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="canEdit" @click='saveInfo(1)'>保存</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="canEdit" @click='cancelClick'>取消</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="orderStatus === '财务审核' && AuthorityList['07_0001_0027_00']" @click="financialAuditeHandler('resolve')">审核成功</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="orderStatus === '财务审核' && AuthorityList['07_0001_0027_00']" @click="financialAuditeHandler('reject')">驳回</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="(orderStatus === '财务审核' && AuthorityList['07_0001_0027_00']) || (orderStatus === '待发货' && AuthorityList['07_0001_0009_00'])" @click="cancelOrder(orderStatus)">取消订单</el-button>
					<el-button class="btn" size="small" plain type="primary" v-if="orderStatus === '已完成'" @click='pushOrder'>推送金额</el-button>
					<el-button class="btn" size="small" plain type='primary' v-if="orderStatus === '已完成' && !JSON.parse(detailData).liquidateFlag && AuthorityList['07_0001_0022_00']" @click="liquidate(1)">勾销</el-button>
					<el-button class="btn" size="small" plain type='primary' v-if="orderStatus === '已完成' && JSON.parse(detailData).liquidateFlag && AuthorityList['07_0001_0022_00']" @click="liquidate(0)">取消勾销</el-button>
					<div class="printcount" v-if="printcount > 0">已打印{{printcount}}次</div>
				</div>
			</div>
			<div class="info-right">
				<DeliveryInfo :editBool="editBool" :detailData="detailData" @orderfollow="orderfollow" @reload='reload' ref="deliveryInfo"/>
			</div>
		</div>
		<el-dialog
			:visible.sync="showPay"
			class="dialog-no-title"
			width="686px"
			:close-on-click-modal="false">
			<pay @closeHandler='closePayDialog' v-if="showPay" :orgin='orgin' :id ='payOrderId'></pay>
		</el-dialog>
		<el-dialog
			title="拒绝原因"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			class="dialog-title"
			width="300px">
			<div class="dialog-body">
				<el-radio-group v-model="refuseValue">
					<el-radio v-for="item in refuseArr" :label="item.id"  :key="item.id">{{item.name}}</el-radio>
				</el-radio-group>
					<el-input  @change='othercauserChange' style="margin-bottom: 10px;" :maxlength="50" :disabled="refuseValue !==10 && refuseValue !==4" type="textarea" v-model="othercauser"></el-input>
				<div class="btn-box">
					<el-button class="btn" size="small" plain type="primary" @click="close">取消</el-button>
					<el-button class="btn" size="small" plain type="primary" @click="refuseOrderConfirm">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			title="取消原因"
			:visible.sync="cancelDialogVisible"
			:close-on-click-modal="false"
			:before-close="closeCancelDialog"
			class="dialog-title"
			width="300px">
			<div class="dialog-body" style="position:relative;">
				<el-radio-group v-model="cancelValue" >
					<el-radio v-for="item in cancelArr" :label="item.id"  :key="item.id" @change="cancelValueSelect(item.id, orderStatus)">{{item.name}}</el-radio>
				</el-radio-group>
					<el-input  @change='cancelcauserChange' @input="cancelcauserInput" style="margin-bottom: 10px;" :maxlength="30" :disabled="(orderStatus === '财务审核' && cancelValue !== 15) || (orderStatus === '待发货' && cancelValue !== 19)" type="textarea" v-model="cancelcauser"></el-input>
					<div style="position:absolute;right:15px;bottom:45px;">{{causerSize}}/30</div>
				<div class="btn-box">
					<el-button class="btn" size="small" plain type="primary" @click="closeCancelDialog">取消</el-button>
					<el-button class="btn" size="small" plain type="primary" @click="financialAuditeCancel">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			:title="deleveryType === 0 ? '填写发货信息' : '发货确认'"
			:visible.sync="expressVisible"
			:close-on-click-modal="false"
			@close="expressClose"
			class="dialog-title"
			width="500px">
			<div class="dialog-body">
				<div class="delivery-box" style="margin-top:15px">
					<span style="flex-shrink: 0">发货方式：</span>
					<el-select v-model="deleveryType" placeholder="请选择快递公司" disabled size="mini" class="delivery-select">
						<el-option :value="0" label="快递"></el-option>
						<el-option :value="1" label="自提"></el-option>
					</el-select>
					<div v-if="deleveryType === 0">
						<span style="margin-left:20px;flex-shrink: 0">快递公司：</span>
						<el-select v-model="companycode" placeholder="请选择快递公司" size="mini" class="delivery-select">
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.value"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="delivery-box" v-if="deleveryType === 0">
					<span>物流单号：</span>
					<el-input
						style="width:250px;"
						size="small"
						v-model="code"
						placeholder="请输入物流单号"
						onkeyup="value=value.replace(/[^a-zA-Z0-9]/ig,'')"
						oninput="if(value.length>50)value=value.slice(0,50)"
					/>
				</div>
				<div class="express-btn">
					<el-button plain size="small" @click="closeExpress">取消</el-button>
					<el-button type="primary" size="small" @click="allSend">确认发货</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			title="添加商品"
			:visible.sync="addGoodsVisible"
			:close-on-click-modal="false"
			class="dialog-title"
			width="700px">
			<div class="add-goods-dialog">
				<div class="add-goods-content">
					<div class="add-goods-item">
						<span>客户名称：</span>
						<div style="line-height:28px;">{{customerName}}</div>
					</div>
					<div class="add-goods-select-box">
						<span>请选择商品：</span>
						<el-select
							size="mini"
							filterable
							remote
							clearable
							v-model="addGoodsValue"
							placeholder="请输入商品名称\SPU编号\第三方编号"
							@change="addGoodsChange"
							@clear="addGoodsClear"
							:remote-method="remoteMethod"
							:loading="loading"
							@keyup.enter.native="enterEvent"
						>
							<el-option
								v-for="item in addGoodsList"
								:key="item.productid"
								:label="item.productName"
								:value="item.productid">
							</el-option>
						</el-select>
					</div>
					<div class="add-goods-info" v-if="goodsInfoShow">
						<div class="add-goods-item">
							<span>商品信息：</span>
							<div class="goods-info-box">
								<img v-if="addGoodsImg === ''" src="~/images/img/no-goods-img.png" alt="">
								<w-image v-else :src="addGoodsImg" alt=""></w-image>
								<div>
									<div>{{addGoodsName}}</div>
									<div v-if="spec_showInventoryFlag ===1 || matchbillcenterflag ===0">库存：{{inventory}}</div>
									<div v-if="minbuycnt !==0">最小起购量：{{minbuycnt}}</div>
								</div>
							</div>
						</div>
						<div class="add-goods-item">
							<span>规格：</span>
							<div class="select-box">
								<span v-show="!item.disableflag" :class="{ active: item.default }" v-for="item in unitArr" :key="item.spec" @click="unitChange(item)">{{item.spec}}</span>
							</div>
						</div>
						<div class="add-goods-item">
							<span>是否是赠送：</span>
							<div class="select-box1">
								<el-switch
									style="margin-right: 5px;"
									:disabled="giftdisableflag"
									v-model="giftflag"
									active-color="#13ce66">
								</el-switch>
								<span v-if="giftflag">赠送</span>
								<span v-else>不赠送</span>
							</div>
						</div>
						<div class="add-goods-item">
							<span>单价：</span>
							<div class="select-box1">
								<span v-if="price === -1">无价</span>
								<span v-else>￥{{addPrice}}</span>
							</div>
						</div>
						<div class="add-goods-item">
							<span>数量：</span>
							<div style="flex:1">
								<div style="display: flex;flex-direction: row;align-items: center;">
									<el-input style="width: 200px;" size="mini" v-model="addGoodsNum" @input='checkNum' @blur="addGoodsNumBlur" @change="addGoodsNumChan"/>
									<div style="min-width: 250px;margin-left: 10px;" v-if='useUnitFlag === 1'>{{unit.assistUnitName}}（1{{unit.assistUnitName}}={{unit.assistRatio}} {{unit.baseUnitName}}）</div>
								</div>
								<span v-if="minbuycntFlag" class="minbuycnt-tips">最小订货数{{minbuycnt}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="btn-box">
					<el-button class="btn" size="small" type="primary" @click="confirmAdd">添加</el-button>
					<el-button class="btn" size="small" plain type="primary" @click="cancelAdd">取消</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			title="编辑实收数量"
			:visible.sync="sendEditDialog"
			:close-on-click-modal="false"
			class="dialog-title"
			width="1200px">
			<editSend
				v-if='sendEditDialog'
				@saveClick='saveSendData'
				@cancelClick='cancelSendData'
				:productData='sendEditTableData'
				:orderdecimalcount='orderdecimalcount'
				:buyerDifferFlag='buyerDifferFlag'
				:orderStatus='orderStatus'
				:matchbillcenterflag='matchbillcenterflag'>
			</editSend>
		</el-dialog>
		<el-dialog
			title="打印设置"
			:visible.sync="printerVisible"
			class="dialog-title"
			width="530px">
				<Print :ids="[orderid]" :templateType="0" v-if="printerVisible"/>
		</el-dialog>
		<el-dialog title="提示" class="confirm-dialog" top='60px' :visible.sync="errorMsgModel" width='400px' :close-on-click-modal="false">
			<div style="margin-bottom:10rpx;max-height:250px;overflow:auto">
				订单修改完确认去发货？
			</div>
			<div style="width:100%;text-align: center;margin-top:40px">
				<el-button size="small" style="width: 120px;" plain type="primary" @click="errorMsgClick('cancel')">取消</el-button>
				<el-button size="small" style="width: 120px;" plain type="primary" @click="errorMsgClick('send')">确认去发货</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提示" class="confirm-dialog" top='60px' :visible.sync="orderTakingModel" width='400px' :close-on-click-modal="false">
			<div style="margin-bottom:10rpx;max-height:250px;overflow:auto">
				订单已经发生修改是否确认接单？
			</div>
			<div style="width:100%;text-align: center;margin-top:40px">
				<el-button size="small" style="width: 120px;" plain type="primary" @click="orderTakingClick('cancel')">取消</el-button>
				<el-button size="small" style="width: 120px;" plain type="primary" @click="orderTakingClick('send')">确认接单</el-button>
			</div>
		</el-dialog>
		<el-dialog title="信用额度不足,无法提单！" class="dialog-title2" :visible.sync="advanceModal" width='400px' :close-on-click-modal="false">
			<div style="font-size:18px;text-align:center">请买家客户支付订单后,再提单！</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="checkDetail">查看未支付订单</el-button>
			</span>
		</el-dialog>
		<el-dialog title="信用额度使用明细" class="dialog-title3" :visible.sync="detailModal" width='800px' :close-on-click-modal="false">
			<div style="margin-bottom:10px;font-size:15px">以下订单使用信用额度,但未支付单据:</div>
			<div class="main-table-box">
				<el-table
					class="grid-content"
					:data="detailDialogData"
					border
					stripe
					height="400"
				>
					<el-table-column
						label-class-name="column-index"
						label="序号"
						type="index"
						width="50"
						align="center">
					</el-table-column>
					<el-table-column
						prop="ordernumber"
						label="订单编号"
						align="center">
					</el-table-column>
					<el-table-column
						prop="shopname"
						label="销售店铺"
						align="center">
					</el-table-column>
					<el-table-column
						prop="money"
						label="订单占用信用额度"
						align="center">
						<template slot-scope="scope">
							<div>￥{{scope.row.money}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="disabledflag"
						label="订单状态"
						align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.billState === 0">待付款</div>
							<div v-if="scope.row.billState === 1">待接单</div>
							<div v-if="scope.row.billState === 2">待发货</div>
							<div v-if="scope.row.billState === 3">待收货</div>
							<div v-if="scope.row.billState === 4">已完成</div>
							<div v-if="scope.row.billState === 5">备货中</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button type='text' size="mini" @click="goDetail(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="detailClose">取 消</el-button>
				<el-button size="small" type="primary" @click="detailClose">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import DetailInfo from '@/components/orderDetail/DetailInfo.vue'
import OrderDetail from '@/components/orderDetail/OrderDetail.vue'
// import GoodsInfo from '@/components/orderDetail/GoodsInfo.vue'
// import PaymentInfo from '@/components/orderDetail/PaymentInfo.vue'
import DeliveryInfo from '@/components/orderDetail/DeliveryInfo.vue'
import editSend from '@/components/orderDetail/editSend.vue'
import Print from '@/components/print/Print.vue'
import pay from '@/components/order/pay.vue'
export default {
	name: 'orderDetail',
	components: {
		DetailInfo,
		OrderDetail,
		// GoodsInfo,
		// PaymentInfo,
		DeliveryInfo,
		editSend,
		Print,
		pay
	},
	data () {
		return {
			taxes: null,
			orderNumber: '',
			useUnitFlag: 0,
			unit: null,
			oldGoods: [],
			addPrice: 0,
			canEdit: false,
			giftdisableflag: false,
			notActivityFlag: false,
			shopName: '',
			billState: '',
			orderStatus: '',
			afterbillflag: false,
			detailData: '',
			dialogVisible: false,
			addGoodsVisible: false,
			expressVisible: false,
			refuseValue: 0,
			refuseArr: [],
			refuseTakeOrder: [
				{ id: 7, name: '库存不足' },
				{ id: 8, name: '未达起送标准' },
				{ id: 9, name: '商品停售' },
				{ id: 10, name: '其他原因' }
			],
			refuseCancelOrder: [
				{ id: 0, name: '商品已经出库' },
				{ id: 1, name: '商品开始生产' },
				{ id: 2, name: '取消理由不合理' },
				{ id: 3, name: '申请已超时' },
				{ id: 4, name: '其他原因' }
			],
			options: [
				{ 'id': 'shunfeng', 'value': '顺丰' },
				{ 'id': 'yuantong', 'value': '圆通' },
				{ 'id': 'yunda', 'value': '韵达' },
				{ 'id': 'shentong', 'value': '申通' },
				{ 'id': 'huitongkuaidi', 'value': '百世' },
				{ 'id': 'zhongtong', 'value': '中通' },
				{ 'id': 'ems', 'value': 'EMS' },
				{ 'id': 'debangwuliu', 'value': '德邦' },
				{ 'id': 'debangkuaidi', 'value': '德邦快递' },
				{ 'id': 'youzhengbk', 'value': '邮政标准快递' },
				{ 'id': 'zhaijisong', 'value': '宅急送' },
				{ 'id': '0', 'value': '其他' }
			],
			cancelstate: false,
			loading: false,
			customerName: '',
			arriveDate: '',
			arriveDateFlag: 0,
			freight: 0,
			sendCountFlag: 0,
			freightFlag: 0,
			priceFlag: 0,
			goodsItemParams: [],
			goodsSendParams: [],
			AuthorityList: {
				'07_0001_0001_00': false,
				'07_0001_0002_00': false,
				'07_0001_0003_00': false,
				'07_0001_0004_00': false,
				'07_0001_0005_00': false,
				'07_0001_0006_00': false,
				'07_0001_0007_00': false,
				'07_0001_0008_00': false,
				'07_0001_0009_00': false,
				'07_0001_0010_00': false,
				'07_0001_0011_00': false,
				'07_0001_0012_00': false,
				'07_0001_0013_00': false,
				'07_0001_0014_00': false,
				'07_0001_0015_00': false,
				'07_0001_0016_00': false,
				'07_0001_0017_00': false,
				'07_0001_0018_00': false,
				'07_0001_0019_00': false,
				'07_0001_0020_00': false,
				'07_0001_0021_00': false,
				'07_0001_0025_00': false,
				'07_0001_0026_00': false,
				'07_0001_0027_00': false
			},
			chlidflag: 0,
			pushstate: 0,
			addGoodsList: [],
			payType: '',
			shopid: '',
			orderid: '',
			productName: '',
			productIds: [],
			goodsInfoShow: false,
			spec: '',
			unitArr: [],
			storeArr: [],
			inventory: 0,
			minbuycnt: 0,
			minbuycntFlag: false,
			addGoodsValue: '',
			attrplanid: '',
			addGoodsNum: 1,
			price: 0,
			initialprice: 0,
			giftflag: 1,
			storeid: '',
			storename: '',
			matchid: '',
			unitName: '',
			addGoodsImg: '',
			addGoodsName: '',
			specCode: '',
			newProducts: [],
			weight: 0,
			punit: '',
			payflag: 0,
			newGoodsSum: 0,
			saveFlag: false,
			printerVisible: false,
			sellerEditFlag: 0,
			matchbillcenterflag: 0,
			othercauser: '',
			orderNumberRoundRules: null,
			orderdecimalcount: null,
			sendEditDialog: false,
			buyerDifferFlag: null,
			sendEditTableData: [],
			confirmOrder: 0,
			sellConfirmOrder: 0,
			reason: '',
			cancelCause: 0,
			canSend: false,
			spec_showInventoryFlag: null,
			canDirectSendflag: false,
			errorMsgModel: false,
			orderTakingModel: false,
			printcount: 0,
			deleveryType: 0,
			companycode: '',
			code: '',
			oldmemo: '',
			userinventoryflag: 0,
			rejectFinancialAuditeFlag: false,
			cancelValue: 11,
			cancelArr: [
				{ id: 11, name: '财务审核不通过' },
				{ id: 12, name: '信息填写有误重新拍' },
				{ id: 13, name: '卖家缺货' },
				{ id: 14, name: '买家拍单错误' },
				{ id: 15, name: '其他原因' }
			],
			cancelArr2: [
				{ id: 16, name: '重复下单' },
				{ id: 17, name: '信息填写有误重新拍' },
				{ id: 18, name: '卖家缺货' },
				{ id: 19, name: '其他原因' }
			],
			cancelDialogVisible: false,
			cancelcauser: '',
			causerSize: 0,
			advanceModal: false,
			detailModal: false,
			detailDialogData: [],
			timer: null,
			percentage: 0,
			preFlag: 0,
			showPay: false,
			payOrderId: '',
			orgin: null,
			payForCustomerFlag: 0,
			bePayMoney: 0,
			showPayFlag: false
		}
	},
	computed: {
		editBool () {
			switch (this.billState) {
			case '0':
				return this.AuthorityList['07_0001_0003_00']
			case '1':
				return this.AuthorityList['07_0001_0006_00']
			case '2':
				if (JSON.parse(window.sessionStorage.getItem('tabInfo')).isSellerpull) {
					return this.AuthorityList['07_0001_0012_00']
				} else {
					return this.AuthorityList['07_0001_0009_00']
				}
			case '3':
				return this.AuthorityList['07_0001_0015_00']
			case '4':
				return this.AuthorityList['07_0001_0018_00']
			case '5':
				return this.AuthorityList['07_0001_0021_00']
			default:
				return true
			}
		},
		editAuthority () {
			return this.AuthorityList['07_0001_0003_00'] || this.AuthorityList['07_0001_0006_00'] || this.AuthorityList['07_0001_0009_00'] || this.AuthorityList['07_0001_0012_00'] || this.AuthorityList['07_0001_0015_00'] || this.AuthorityList['07_0001_0018_00'] || this.AuthorityList['07_0001_0021_00']
		}
	},
	created () {
		this.$fxEventBus.$on('reloadOrder', () => {
			window.sessionStorage.removeItem('createdate')
			this.$fxEventBus.$emit('setMenu', '6-1')
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
			this.orderid = orderParams.orderId
			switch (orderParams.billState) {
			case '待付款':
				this.billState = '0'
				break
			case '待接单':
				this.billState = '1'
				break
			case '待发货':
				this.billState = '2'
				break
			case '备货中':
				this.billState = '2'
				break
			case '待收货':
				this.billState = '3'
				break
			case '已完成':
				this.billState = '4'
				break
			case '已取消':
				this.billState = '5'
				break
			case '财务审核':
				this.billState = '6'
				break
			}
			this.getDetail(orderParams, tabParams)
			this.getAuthority('07_0001_0000_00')
			this.checkSmallCategory()
			this.getSystemSetting()
		})
		window.sessionStorage.removeItem('createdate')
		this.$fxEventBus.$emit('setMenu', '6-1')
		let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
		let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
		this.orderid = orderParams.orderId
		switch (orderParams.billState) {
		case '待付款':
			this.billState = '0'
			break
		case '待接单':
			this.billState = '1'
			break
		case '待发货':
			this.billState = '2'
			break
		case '备货中':
			this.billState = '2'
			break
		case '待收货':
			this.billState = '3'
			break
		case '已完成':
			this.billState = '4'
			break
		case '已取消':
			this.billState = '5'
			break
		case '财务审核':
			this.billState = '6'
			break
		}
		this.getDetail(orderParams, tabParams)
		this.getAuthority('07_0001_0000_00')
		this.checkSmallCategory()
		this.getSystemSetting()
	},
	methods: {
		closePayDialog () {
			this.showPay = false
			this.reload()
		},
		payClick () {
			this.orgin = 'detail'
			this.payOrderId = JSON.parse(window.sessionStorage.getItem('orderInfo')).orderId
			this.showPay = true
		},
		reload () {
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
			this.getDetail(orderParams, tabParams)
		},
		checkDetail () {
			this.detailModal = true
		},
		detailClose () {
			this.detailModal = false
		},
		goDetail (row) {
			let orderParams = {}
			orderParams.orderId = row.orderid
			orderParams.statusId = row.statusId
			orderParams.differ = row.differ
			orderParams.buypullstate = row.buypullstate
			switch (row.billState) {
			case 0:
				orderParams.billState = '待付款'
				break
			case 1:
				orderParams.billState = '待接单'
				break
			case 2:
				orderParams.billState = '待发货'
				break
			case 3:
				orderParams.billState = '待收货'
				break
			case 4:
				orderParams.billState = '已完成'
				break
			case 5:
				orderParams.billState = '已取消'
				break
			}
			window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
			let tabInfo = {}
			tabInfo.active = orderParams.billState
			tabInfo.isSellerpull = false
			tabInfo.orderStatus = row.billState
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabInfo))
			this.detailModal = false
			this.advanceModal = false
			this.addGoodsVisible = false
			this.$fxEventBus.$emit('reloadOrder')
			// this.$router.push('/main/orderDetail')
		},
		orderfollow (data) {
			this.reason = data[0].reason
		},
		cancelSendData () {
			this.sendEditDialog = false
		},
		saveSendData (data, status) {
			let list = []
			for (let i = 0; i < data.length; i++) {
				let item = data[i]
				if (status === '待收货' && item.check) {
					// 屏蔽无用判断 2021/3/4
					// if (item.buyDiffCount === '' || item.buyDiffCount === undefined) {
					// 	this.$message.error('【' + item.orderItemProductName + '】调整量不能为空')
					// 	return false
					// }
					// if (+item.buyDiffCount === 0) {
					// 	this.$message.error('【' + item.orderItemProductName + '】调整量不能为0')
					// 	return false
					// }
					// if (+item.buyDiffCount > 999999) {
					// 	this.$message.error('【' + item.orderItemProductName + '】调整量不能超过999999')
					// 	return false
					// }
					list.push(item)
				} else {
					if (item.getCount === '' || item.getCount === undefined) {
						this.$message.error('【' + item.orderItemProductName + '】已收量不能为空')
						return false
					}
					if (+item.getCount < 0) {
						this.$message.error('【' + item.orderItemProductName + '】已收量不能小于0')
						return false
					}
					// if (+item.getCount > 999999) {
					// 	this.$message.error('【' + item.orderItemProductName + '】已收量不能超过999999')
					// 	return false
					// }
					list.push(item)
				}
			}
			let params = {
				orderId: JSON.parse(window.sessionStorage.getItem('orderInfo')).orderId,
				statusId: JSON.parse(window.sessionStorage.getItem('orderInfo')).statusId,
				orderStatus: this.billState,
				orderItemProductDTOList: list
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/quantityandprice/update`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sendEditDialog = false
					this.$message.success('保存成功！')
					let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
					let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
					this.getDetail(orderParams, tabParams)
				} else {
					let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
					this.$message.error(resMsg)
				}
			}).catch((err) => {
				if (err.code === '2632') {
					this.$message.error(err.msg)
				} else {
					this.$message.error('订单状态已改变!')
				}
			})
		},
		cancelClick () {
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
			this.getDetail(orderParams, tabParams)
		},
		sendEditClick () {
			let list = this.$refs.infoRef.productData
			list.forEach(item => {
				item.check = false
				item.show = true
			})
			this.sendEditTableData = JSON.parse(JSON.stringify(list))
			this.sendEditDialog = true
		},
		expressClose () {
			this.deleveryType = 0
			this.companycode = ''
			this.code = ''
		},
		closeExpress () {
			this.expressVisible = false
		},
		openSend () {
			if (this.canSend) {
				this.expressVisible = true
			} else {
				this.$message.error('有未支付子订单，不允许发货，请买家支付后，才能发货！')
				return false
			}
		},
		allSend () {
			let params = {
				orderid: this.orderid,
				statusid: JSON.parse(window.sessionStorage.getItem('orderInfo')).statusId,
				orderstatus: 2,
				action: 3,
				sendtype: this.deleveryType
			}
			if (this.deleveryType === 0) {
				let companyname = ''
				this.options.forEach(item => {
					if (item.id === this.companycode) {
						companyname = item.value
					}
				})
				params.express = {
					companyname: companyname,
					companycode: this.companycode,
					number: this.code
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/update/statusAndFulfillment`,
				data: params
			}).then(res => {
				if (res.result) {
					this.expressVisible = false
					this.$message.success('发货成功！')
				} else {
					let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
					this.$message.error(resMsg)
				}
				let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
				let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
				this.getDetail(orderParams, tabParams)
			}).catch(() => {
				this.$message.error('订单状态已改变!')
			})
		},
		checkNum () {
			this.addGoodsNum = this.addGoodsNum.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.addGoodsNum = this.addGoodsNum.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.addGoodsNum = this.addGoodsNum.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.addGoodsNum = this.addGoodsNum.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.orderdecimalcount) {
			case 0:
				this.addGoodsNum = this.addGoodsNum.replace(/[^0-9]/g, '')// 只能输入数字
				break
			case 1:
				this.addGoodsNum = this.addGoodsNum.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')// 只能输入一个小数
				break
			case 2:
				this.addGoodsNum = this.addGoodsNum.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入一个小数
				break
			case 3:
				this.addGoodsNum = this.addGoodsNum.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')// 只能输入一个小数
				break
			case 4:
				this.addGoodsNum = this.addGoodsNum.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')// 只能输入一个小数
				break
			}
		},
		getSystemSetting () {
			var params = {
				orderid: this.orderid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/order/getOrderSystemSetting`,
				data: params
			}).then(res => {
				this.orderNumberRoundRules = res.data.ordermoneyroundrules
				this.orderdecimalcount = res.data.orderdecimalcount
				this.buyerDifferFlag = res.data.buyerDifferFlag
				this.canDirectSendflag = res.data.canDirectSendflag
				this.userinventoryflag = res.data.userinventoryflag
			})
		},
		othercauserChange () {
			this.othercauser = this.othercauser.trim()
			this.othercauser = this.othercauser.replace(/[',\\]/g, '')
		},
		cancelcauserChange () {
			this.cancelcauser = this.cancelcauser.trim()
			this.cancelcauser = this.cancelcauser.replace(/[',\\]/g, '')
		},
		cancelcauserInput () {
			this.causerSize = this.cancelcauser.length
		},
		// 是否开启小类
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag
			})
			// })
		},
		printerEvent () {
			this.printerVisible = true
		},
		goPay () {
			if (this.newProducts.length > 0) {
				this.$message.error('请先保存新增商品！')
				return false
			}
			if (this.saveFlag) {
				this.$message.error('请先保存编辑信息！')
				return false
			}
			this.$confirm('订单是否完成编辑？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.goPayPost()
			}).catch(() => {})
		},
		//	买家去确认
		goCheck () {
			let that = this
			this.$confirm('订单是否完成编辑?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					orderid: this.orderid,
					statusid: JSON.parse(window.sessionStorage.getItem('orderInfo')).statusId,
					orderstatus: this.billState
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/order/buyerconfirm`,
					data: params
				}).then(res => {
					let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
					let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
					if (res.result) {
						that.getDetail(orderParams, tabParams)
					} else {
						that.$message.error(res.msg)
					}
				})
			}).catch(() => {
			})
		},
		goPayPost () {
			let params = {
				orderid: this.orderid,
				payflag: 2,
				statusid: JSON.parse(window.sessionStorage.getItem('orderInfo')).statusId,
				orderstatus: this.billState
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/order/update/payflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.payflag = 2
					this.$message.success('修改成功！')
					let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
					let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
					this.getDetail(orderParams, tabParams)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		deleteNew (data) {
			let index = null
			let list = this.$refs.infoRef.productData
			list.forEach((item, i) => {
				if (data.oipid === item.orderItemProductId) {
					index = i
				}
			})
			// console.log(index)
			this.deleteGoods(data, index)
		},
		handleClick (data) {
			// console.log(data)
			if (data === 'first') {
				clearTimeout(this.timer)
			}
		},
		deleteGoods (data, index) {
			let delprodct = {
				msg: '[' + this.orderNumber + ']删除' + data.msg
			}
			const logger = this.$fxLogger.createInfo('order.order_detail.delProduct', delprodct)
			let params = {
				orderid: this.orderid,
				orderItemId: data.oiid,
				statusid: JSON.parse(window.sessionStorage.getItem('orderInfo')).statusId,
				orderItemProductId: data.oipid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/order/delete/newproduct`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功！')
					this.$refs.infoRef.delGood(index)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		goDeliverManage (item) {
			if (this.canSend) {
				this.$router.push('/main/deliverManage')
			} else {
				this.$message.error('有未支付子订单，不允许发货，请买家支付后，才能发货！')
				return false
			}
		},
		goDeliverHistory () {
			window.sessionStorage.setItem('historyoiid', 0)
			this.$router.push('/main/deliverHistory')
		},
		cancelAdd () {
			this.addGoodsVisible = false
		},
		confirmAdd () {
			this.addGoods()
		},
		addGoods () {
			console.log(this.unit)
			if (!this.goodsInfoShow) {
				this.$message.error('请选择商品后再添加！')
				return false
			}
			if ((+this.addGoodsNum) === 0) {
				this.$message.error('【' + this.addGoodsName + '】订货数量不能为0！')
				return false
			}
			if (this.inventory < 1 && this.userinventoryflag === 1) {
				this.$message.error('库存不足，无法添加')
				return false
			}
			if (!this.giftflag && +this.price < 0) {
				this.$message.error('当前商品价格为负值，无法提交！')
				return false
			}
			let curGoodsInfo = {
				productid: this.addGoodsValue,
				attrplanid: this.attrplanid,
				itemquantity: this.addGoodsNum,
				giftflag: this.giftflag ? 1 : 0,
				storeid: this.storeid,
				storename: this.storename,
				matchid: this.matchid,
				url: this.addGoodsImg,
				price: !this.giftflag ? this.addPrice : 0,
				useUnitFlag: this.useUnitFlag,
				assistRatio: this.unit.assistRatio,
				assistUnitId: this.unit.assistUnitId,
				assistUnitName: this.unit.assistUnitName,
				baseUnitId: this.unit.baseUnitId,
				baseUnitName: this.unit.baseUnitName,
				taxes: this.taxes
			}
			let params = {
				buyerSellerType: 1,
				orderstatus: this.billState,
				action: 4,
				orderid: this.orderid,
				statusid: JSON.parse(window.sessionStorage.getItem('orderInfo')).statusId,
				newProducts: [curGoodsInfo],
				pname: this.addGoodsName,
				specCode: this.specCode
			}
			let addprodct = {
				msg: '[' + this.orderNumber + ']' + '新增' + (this.giftflag ? '赠品' : '商品') + '[' + this.addGoodsName + '-' + this.spec + '][' + this.addGoodsNum + ']个[' + this.addPrice + ']元'
			}
			const logger = this.$fxLogger.createInfo('order.order_detail.addProduct', addprodct)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/update`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
					let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
					this.getDetail(orderParams, tabParams)
					this.$message.success('添加成功！')
					this.addGoodsVisible = false
				} else if (res.code === 4009) {
					res.data.forEach(e => {
						e.money = this.$fxUtils.toFixedSHW(e.money, 2)
					})
					this.detailDialogData = res.data
					this.advanceModal = true
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		toFix (price) {
			if (+price === 0) {
				return '0.00'
			}
			let num = isNaN(price) ? 0 : price
			num = +num + 0.0000000001
			num = num + ''
			num = num.substring(0, num.indexOf('.') + 3)
			return num
		},
		changeStore (item) {
			this.storeArr.forEach(i => {
				i.default = false
				if (item.storeid === i.storeid) {
					i.default = true
					this.storeid = item.storeid
					this.storename = item.storename
					this.matchid = item.matchid
				}
			})
		},
		unitChange (item) {
			this.unitArr.forEach(i => {
				i.default = false
				if (item.spec === i.spec) {
					i.default = true
					this.attrplanid = item.attrplanid
					this.spec = item.spec
					this.spec_showInventoryFlag = item.spec_showInventoryFlag
					this.minbuycnt = item.minbuycnt
					this.addGoodsImg = item.url
					this.spec = item.spec
					this.price = item.private_price
					this.initialprice = item.private_price
					let baseprice = item.private_price ? item.private_price : item.public_price
					this.addPrice = this.useUnitFlag === 1 ? this.toFix(baseprice * item.unit.assistRatio) : baseprice
					this.addGoodsNum = this.minbuycnt
					this.giftflag = item.giftflag
					this.giftdisableflag = item.giftdisableflag
					this.taxes = item.taxes
					this.useUnitFlag = item.useUnitFlag
					this.specCode = item.specCode
					if (this.useUnitFlag === 1) {
						this.unit = item.unit
						this.inventory = this.toFix(item.inventory / item.unit.assistRatio)
					} else {
						this.inventory = item.inventory
						this.unit = {
							assistRatio: '',
							assistUnitId: '',
							assistUnitName: '',
							baseUnitId: '',
							baseUnitName: ''
						}
					}
				}
			})
		},
		enterEvent (e) {
			this.productName = e.target.value
			this.addGoodsEvent()
		},
		addGoodsChange () {
			let params = {
				id: this.addGoodsValue,
				orderid: this.orderid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getProductDetail`,
				data: params
			}).then(res => {
				if (res.result) {
					this.addGoodsName = res.data.product.productName
					this.weight = res.data.product.weight
					let flag = true
					res.data.unit_spec.forEach((item, index) => {
						if (index === 0) {
							if (item.disableflag) {
								item.default = false
							} else {
								flag = false
								item.default = true
								this.useUnitFlag = item.useUnitFlag
								if (this.useUnitFlag === 1) {
									this.unit = item.unit
									this.inventory = this.toFix(item.inventory / item.unit.assistRatio)
								} else {
									this.inventory = item.inventory
									this.unit = {
										assistRatio: '',
										assistUnitId: '',
										assistUnitName: '',
										baseUnitId: '',
										baseUnitName: ''
									}
								}
								this.giftflag = item.giftflag
								this.giftdisableflag = item.giftdisableflag
								this.spec_showInventoryFlag = item.spec_showInventoryFlag
								this.spec = item.spec
								this.addGoodsImg = item.url
								this.price = item.private_price
								this.spec = item.spec
								this.initialprice = item.private_price
								let baseprice = item.private_price ? item.private_price : item.public_price
								this.addPrice = this.useUnitFlag === 1 ? this.toFix(baseprice * item.unit.assistRatio) : baseprice
								this.minbuycnt = item.minbuycnt
								this.addGoodsNum = this.minbuycnt > 0 ? this.minbuycnt : 1
								this.attrplanid = item.attrplanid
								this.specCode = item.specCode
								this.taxes = item.taxes
							}
						} else {
							if (flag && !item.disableflag) {
								flag = false
								item.default = true
								this.useUnitFlag = item.useUnitFlag
								if (this.useUnitFlag === 1) {
									this.unit = item.unit
									this.inventory = this.toFix(item.inventory / item.unit.assistRatio)
								} else {
									this.inventory = item.inventory

									this.unit = {
										assistRatio: '',
										assistUnitId: '',
										assistUnitName: '',
										baseUnitId: '',
										baseUnitName: ''
									}
								}
								this.giftflag = item.giftflag
								this.giftdisableflag = item.giftdisableflag
								this.spec_showInventoryFlag = item.spec_showInventoryFlag
								this.spec = item.spec
								this.addGoodsImg = item.url
								this.price = item.private_price
								this.spec = item.spec
								this.initialprice = item.private_price
								this.taxes = item.taxes
								// this.minbuycnt = item.minbuycnt > 0 ? item.minbuycnt : 1
								let baseprice = item.private_price ? item.private_price : item.public_price
								this.addPrice = this.useUnitFlag === 1 ? this.toFix(baseprice * item.unit.assistRatio) : baseprice
								this.minbuycnt = item.minbuycnt
								this.addGoodsNum = this.minbuycnt > 0 ? this.minbuycnt : 1
								this.attrplanid = item.attrplanid
								this.specCode = item.specCode
							} else {
								item.default = false
							}
						}
					})
					this.unitArr = JSON.parse(JSON.stringify(res.data.unit_spec))
					res.data.store.forEach((item, index) => {
						item.default = false
						if (index === 0) {
							item.default = true
							this.storeid = item.storeid
							this.storename = item.storename
							this.matchid = item.matchid
						}
					})
					this.storeArr = res.data.store
					this.goodsInfoShow = true
				}
			})
		},
		addGoodsClear () {
			this.productName = ''
			this.addGoodsEvent()
		},
		addGoodsEvent () {
			this.goodsInfoShow = false
			this.addGoodsList = []
			this.addGoodsValue = ''
			if (!this.addGoodsVisible) {
				this.productName = ''
			}
			this.minbuycntFlag = false
			let params = {
				shopid: this.shopid,
				orderid: this.orderid,
				productName: this.productName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/goods/getProductList`,
				data: params
			}).then(res => {
				if (res.result) {
					this.addGoodsList = res.data
					this.addGoodsVisible = true
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 查询商品
		remoteMethod (query) {
			// if (query !== '') {
			this.loading = true
			let data = {
				keyword: query,
				shopid: this.shopid,
				orderid: this.orderid,
				productName: this.productName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/goods/getProductList`,
				data: data
			}).then(res => {
				if (res.result) {
					this.loading = false
					this.addGoodsList = res.data
					// for (let i = 0; i < this.options.length; i++) {
					// 	if (this.value === this.options[i].userid) {
					// 		this.buyersyscodeid = this.options[i].buyersyscodeid
					// 		break
					// 	}
					// }
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		editGoods () {
			this.canEdit = true
			this.$refs.infoRef.activeName = 'first'
		},
		addGoodsNumBlur () {
			if (!this.addGoodsNum) {
				if (this.minbuycnt > 0) {
					this.minbuycntFlag = true
				}
				this.addGoodsNum = 1
			}
			if (this.minbuycnt > 0 && this.addGoodsNum < this.minbuycnt) {
				this.minbuycntFlag = true
			} else {
				this.minbuycntFlag = false
			}
		},
		addGoodsNumChan (value) {
			if (this.minbuycnt > 0 && value < this.minbuycnt) {
				this.minbuycntFlag = true
			} else {
				this.minbuycntFlag = false
			}
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		goBack (mode) {
			let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
			tabParams.isSellerpull = false
			tabParams.active = this.orderStatus
			if (mode === 'all') {
				tabParams.orderStatus = 8
				tabParams.active = '全部订单'
			} else {
				switch (this.orderStatus) {
				case '待付款':
					tabParams.orderStatus = 0
					break
				case '待接单':
					tabParams.orderStatus = 1
					break
				case '待发货':
					tabParams.orderStatus = 2
					break
				case '备货中':
					tabParams.orderStatus = 2
					tabParams.isSellerpull = true
					break
				case '待收货':
					tabParams.orderStatus = 3
					break
				case '已完成':
					tabParams.orderStatus = 4
					break
				case '已取消':
					tabParams.orderStatus = 5
					break
				case '财务审核':
					tabParams.orderStatus = 6
					break
				}
			}
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
			this.$router.push('/main/order')
		},
		getDetail (orderParams1, tabParams) {
			let windowId = window.sessionStorage.getItem('windowId')
			let params = {
				windowId: windowId,
				orderId: orderParams1.orderId,
				// statusid: orderParams.statusId,
				// isSellerpull: tabParams.isSellerpull,
				// isBuyer: false,
				// differ: '' + orderParams.differ,
				// buypullstate: orderParams.buypullstate,
				// billState: this.billState,
				messageid: orderParams1.messageid || ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/detail`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$fxEventBus.$emit('getMsgNum')
					window.sessionStorage.removeItem('windowId')
					let orderChildNumber = window.sessionStorage.getItem('orderChildNumber')
					if (orderChildNumber) {
						this.$refs.infoRef.activeName = 'second'
						this.$refs.infoRef.orderCode = orderParams1.orderId
						this.$refs.infoRef.goChildOrder(orderChildNumber)
						window.sessionStorage.removeItem('orderChildNumber')
					} else {
						this.$refs.infoRef.activeName = 'first'
					}
					this.payForCustomerFlag = res.data.payForCustomerFlag
					this.showPayFlag = res.data.showPayFlag
					this.bePayMoney = res.data.bePayMoney
					this.orderNumber = res.data.orderNumber
					this.deleveryType = res.data.selfPickFlag ? 1 : 0
					this.oldmemo = res.data.memo
					this.sellerEditFlag = res.data.sellerEditFlag
					this.payflag = res.data.payFlag
					this.shopid = res.data.shopId
					this.canSend = res.data.canSend
					this.confirmOrder = res.data.confirmOrder
					this.sellConfirmOrder = res.data.sellConfirmOrder
					this.printcount = res.data.printCount
					this.lockFlag = res.data.lockFlag
					this.preFlag = res.data.preFlag
					this.customerName = res.data.customerName
					if (res.data.cancelCause === null) {
						this.cancelCause = 0
					}
					this.chlidflag = res.data.chlidflag
					if (res.data.isCancel) {
						this.orderStatus = '已取消'
					} else {
						switch (res.data.orderStatus) {
						case 0:
							this.orderStatus = '待付款'
							break
						case 1:
							this.orderStatus = '待接单'
							break
						case 2:
							if (res.data.pushState === 3) {
								this.orderStatus = '备货中'
							} else {
								this.orderStatus = '待发货'
							}
							break
						case 3:
							this.orderStatus = '待收货'
							break
						case 4:
							this.orderStatus = '已完成'
							break
						case 6:
							this.orderStatus = '财务审核'
							break
						}
					}
					this.detailData = JSON.stringify(res.data)
					this.oldGoods = res.data.orderItemProductDTOList
					let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
					let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
					if (res.data.cancelState === 1) {
						this.cancelstate = true
					} else {
						this.cancelstate = false
					}
					if (res.data.isCancel) {
						this.billState = '5'
						orderParams.billState = '已取消'
						this.orderStatus = '已取消'
						tabParams.active = '已取消'
						tabParams.orderStatus = 5
						tabParams.isSellerpull = false
					} else {
						if (res.data.orderStatus === 3) {
							this.orderStatus = '待收货'
							orderParams.billState = '待收货'
							tabParams.active = '待收货'
							tabParams.isSellerpull = false
							tabParams.orderStatus = 3
							this.billState = '3'
						}
						if (res.data.orderStatus === 0) {
							this.orderStatus = '待付款'
							orderParams.billState = '待付款'
							tabParams.active = '待付款'
							tabParams.isSellerpull = false
							tabParams.orderStatus = 0
							this.billState = '0'
						}
						if (res.data.orderStatus === 1) {
							this.orderStatus = '待接单'
							orderParams.billState = '待接单'
							tabParams.active = '待接单'
							tabParams.isSellerpull = false
							tabParams.orderStatus = 1
							this.billState = '1'
						}
						if (res.data.orderStatus === 4) {
							this.orderStatus = '已完成'
							orderParams.billState = '已完成'
							tabParams.active = '已完成'
							tabParams.isSellerpull = false
							tabParams.orderStatus = 4
							this.billState = '4'
						}
						if (res.data.orderStatus === 2) {
							this.billState = '2'
							tabParams.orderStatus = 2
							if (res.data.pushState === 3) {
								this.orderStatus = '备货中'
								orderParams.billState = '备货中'
								tabParams.active = '备货中'
								tabParams.isSellerpull = true
							} else {
								this.orderStatus = '待发货'
								orderParams.billState = '待发货'
								tabParams.active = '待发货'
								tabParams.isSellerpull = false
							}
						}
					}
					window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
					if (!window.sessionStorage.getItem('tabInfo')) {
						window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
					}
					this.canEdit = false
				} else {
					let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
					this.$message.error(resMsg)
				}
			})
		},
		confirmOrAccept (action) {
			if (action === 2 && (this.canEdit || this.newProducts.length > 0)) {
				this.$message.error('该订单已被修改，请先保存！')
				return false
			}
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let params = {
				orderid: orderParams.orderId,
				statusid: orderParams.statusId,
				orderstatus: this.billState,
				action: action,
				operateCode: 1020
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/update/status`,
				data: params
			}).then(res => {
				if (res.result) {
					let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
					let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
					if (action === 3) {
						if (this.pushstate !== 1 && this.matchbillcenterflag === 1) {
							this.$message.success('数据已经同步供应链系统、订单状态改变成功！')
						} else {
							this.$message.success('发货成功！')
						}

						this.billState = '3'
						orderParams.billState = '待收货'
						this.orderStatus = '待收货'
						tabParams.active = '待收货'
						tabParams.orderStatus = 3
					} else if (action === 2) {
						if (!this.errorMsgModel) {
							this.$message.success('接单成功！')
							if (this.orderTakingModel) {
								this.orderTakingModel = !this.orderTakingModel
							}
						} else {
							this.errorMsgModel = false
						}
						this.billState = '2'
						orderParams.billState = '待发货'
						this.orderStatus = '待发货'
						tabParams.active = '待发货'
						tabParams.orderStatus = 2
					}
					window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
					window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
					this.getDetail(orderParams, tabParams)
				} else {
					let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
					this.$message.error(resMsg)
				}
			}).catch(() => {
				this.$message.error('订单状态已改变!')
			})
		},
		refuseOrder (type) {
			if (type === 'take') {
				this.refuseArr = this.refuseTakeOrder
				this.refuseValue = 7
			} else {
				this.refuseArr = this.refuseCancelOrder
				this.refuseValue = 0
			}
			this.dialogVisible = true
		},
		close () {
			this.dialogVisible = false
		},
		refuseOrderConfirm () {
			if (this.orderStatus === '待接单') {
				let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
				let params = {
					orderid: orderParams.orderId,
					statusid: orderParams.statusId,
					buyerSellerType: '1',
					othercauser: this.othercauser,
					cancelcause: this.refuseValue,
					orderstatus: this.billState,
					operateCode: 2040
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/order/cancel`,
					data: params
				}).then(res => {
					if (res.result) {
						this.dialogVisible = false
						let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
						let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
						this.$message.success('拒单成功！')
						this.billState = '5'
						orderParams.billState = '已取消'
						this.orderStatus = '已取消'
						tabParams.active = '已取消'
						tabParams.orderStatus = 5
						window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
						window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
						this.getDetail(orderParams, tabParams)
					} else {
						let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
						this.$message.error(resMsg)
					}
				}).catch(() => {
					this.$message.error('订单状态已改变!')
				})
			} else {
				this.agreenRefuseCancel(false)
			}
		},
		agreenRefuseCancel (bool) {
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let params = {}
			if (bool) {
				params = {
					orderid: orderParams.orderId,
					statusid: orderParams.statusId,
					buyerSellerType: '1',
					isAgreeCancel: bool,
					orderstatus: this.billState
				}
			} else {
				params = {
					orderid: orderParams.orderId,
					statusid: orderParams.statusId,
					buyerSellerType: '1',
					othercauser: this.othercauser,
					isAgreeCancel: bool,
					cancelcause: this.refuseValue,
					orderstatus: this.billState
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/agreecancel`,
				data: params
			}).then(res => {
				if (res.result) {
					this.dialogVisible = false
					let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
					let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
					if (bool) {
						this.$message.success('同意取消成功！')
						this.billState = '5'
						orderParams.billState = '已取消'
						this.orderStatus = '已取消'
						tabParams.active = '已取消'
						tabParams.orderStatus = 5
					} else {
						this.$message.success('拒绝取消成功！')
					}
					window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
					window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
					this.getDetail(orderParams, tabParams)
				} else {
					let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
					this.$message.error(resMsg)
				}
			}).catch(() => {
				this.$message.error('订单状态已改变!')
			})
		},
		arriveDateChange (value) {
			this.arriveDate = value.arriveDate
			this.arriveDateFlag = value.flag
		},
		orderTakingModel2 (value) {
			this.orderTakingModel = value
		},
		freightChange (value) {
			this.freightFlag = value.flag
			this.freight = value.freight
		},
		sendCounChange (value) {
			this.sendCountFlag = value.flag
			this.goodsSendParams = value.goodsSendParams
		},
		priceChange (value) {
			this.priceFlag = value.flag
			let detailData = JSON.parse(this.detailData)
			detailData.goodsData.forEach(item => {
				value.goodsItemParams.forEach(i => {
					if (item.attrplanid === i.attrplanid) {
						item.itemquantity = i.itemquantity
						item.price = i.price
					}
				})
			})
			this.detailData = JSON.stringify(detailData)
			if (value.new) {
				this.newProducts = value.goodsItemParams
			} else {
				this.goodsItemParams = value.goodsItemParams
			}
		},
		pushOrder () {
			let params = {
				orderId: JSON.parse(window.sessionStorage.getItem('orderInfo')).orderId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/pushOrderPayment`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('推送成功!')
				} else {
					this.$message.error(res.msg)
				}
			}).catch((err) => {
				this.$message.error(err.msg)
			})
		},
		saveInfo (action) {
			let oldList = this.oldGoods
			let newList = this.$refs.infoRef.mockProductData
			let newmemo = this.$refs.infoRef.memo
			let num = 0
			let deleteSize = oldList.length - newList.length
			let msgArr = []
			for (let i = 0; i < newList.length; i++) {
				let item = newList[i]
				if (item.itemQuantity === '' || item.itemQuantity === undefined) {
					this.$message.error('商品数量不可为空')
					return false
				}
				if (+item.orderItemProductPrice > 999999.99) {
					this.$message.error('【' + item.orderItemProductName + '】单价不能超过999999.99')
					return false
				}
				// item.liveMoney = (+item.liveMoney) + (+item.fullMinusCouponMoney) + ''
				oldList.forEach(item1 => {
					if (item.orderItemId === item1.orderItemId) {
						if (item.assistQuantity !== item1.assistQuantity || item.orderItemMemo !== item1.orderItemMemo || +item.liveMoney !== +item1.liveMoney || +item.itemQuantity !== +item1.itemQuantity || +item.orderItemProductPrice !== +item1.orderItemProductPrice) {
							num++
							let text = ''
							if (item.itemQuantity !== item1.itemQuantity) {
								text = text + '数量由' + item1.itemQuantity + '修改为' + item.itemQuantity
							}
							if (+item.orderItemProductPrice !== +item1.orderItemProductPrice) {
								text = text + '实际单价由' + item1.orderItemProductPrice + '修改为' + item.orderItemProductPrice
							}
							if (+item.liveMoney !== +item1.liveMoney) {
								text = text + '实付额由' + item1.liveMoney + '修改为' + item.liveMoney
							}
							let msgRow = '[' + item.specCode + '][' + item.orderItemProductName + '-' + item.spec + ']' + text
							msgArr.push(msgRow)
						}
					}
				})
			}
			if (deleteSize > 0) {
				num += deleteSize
			}
			this.$confirm('确认修改' + num + '个商品品项', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				if (num === 0 && this.oldmemo === newmemo) {
					this.canEdit = false
					let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
					let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
					this.getDetail(orderParams, tabParams)
					return false
				}
				const logger = this.$fxLogger.createInfo('order.order_detail.editProduct', { msg: '[' + this.orderNumber + ']' + msgArr.join(',') })
				let params = {
					orderId: JSON.parse(window.sessionStorage.getItem('orderInfo')).orderId,
					statusId: JSON.parse(window.sessionStorage.getItem('orderInfo')).statusId,
					orderStatus: this.billState,
					orderItemProductDTOList: newList
					// memo: newmemo
				}
				// console.log(newList)
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/order/quantityandprice/update`,
					data: params,
					logger
				}).then(res => {
					if (res.result) {
						this.canEdit = false
						this.$message.success('保存成功！')
						let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
						let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
						this.getDetail(orderParams, tabParams)
					} else if (res.code === 4009) {
						res.data.forEach(e => {
							e.money = this.$fxUtils.toFixedSHW(e.money, 2)
						})
						this.detailDialogData = res.data
						this.advanceModal = true
					} else {
						let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
						this.$message.error(resMsg)
					}
				}).catch((err) => {
					if (err.code === '2632') {
						this.$message.error(err.msg)
					} else {
						this.$message.error('订单状态已改变!')
					}
				})
			}).catch(() => {

			})
		},
		pushOrderToCldCheck () {
			if (this.cancelstate) {
				this.$confirm('该订单买家申请取消中，是否要处理?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.pushOrderToCld()
				}).catch(() => {
				})
			} else {
				this.pushOrderToCld()
			}
		},
		pushOrderToCld () {
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let params = {
				orderid: orderParams.orderId,
				statusid: orderParams.statusId,
				orderstatus: this.billState
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/dockcld/handPushOrderToCld`,
				data: params
			}).then(res => {
				if (res.result) {
					// 3 待收货   2 备货中
					if (res.data.pullState === 1) {
						this.$message.success('数据已经同步供应链系统、订单状态改变成功！')
					} else {
						this.$message.success('同步成功！')
					}
					let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
					let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
					if (res.data.orderStatus === 3) {
						this.billState = '3'
						orderParams.billState = '待收货'
						this.orderStatus = '待收货'
						tabParams.active = '待收货'
						tabParams.orderStatus = 3
					} else if (res.data.orderStatus === 2) {
						this.billState = '2'
						orderParams.billState = '备货中'
						this.orderStatus = '备货中'
						tabParams.active = '备货中'
						tabParams.isSellerpull = true
						tabParams.orderStatus = 2
					}
					window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
					window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
					this.getDetail(orderParams, tabParams)
				} else {
					this.$message.error(res.msg)
				}
			}).catch((e) => {
				this.$message.error(e.msg)
			})
		},
		// 导出
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/orderDetail/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			let data = {
				orderid: this.orderid,
				orderstatusname: this.orderStatus
			}
			req.send(JSON.stringify(data))
		},
		download (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			let detailData = JSON.parse(this.detailData)
			let customerName = detailData.customerName
			let createdate = detailData.orderCreateDate.split(' ')[0].replace(/-/g, '')
			let ordernumber = detailData.orderNumber
			let name = customerName + createdate + this.orderStatus + ordernumber + '.xls'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		goSendGoods () {
			this.errorMsgModel = true
		},
		errorMsgClick (val) {
			if (val === 'cancel') {
				this.errorMsgModel = false
			} else if (val === 'send') {
				this.confirmOrAccept(2)
			}
		},
		orderTakingClick (val) {
			if (val === 'cancel') {
				this.orderTakingModel = false
			} else if (val === 'send') {
				this.confirmOrAccept(2)
			}
		},

		loop () {
			this.timer = setTimeout(() => {
				this.check()
				this.loop()
			}, 1000)
		},
		clearTimer () {
			let params = {
				operate: 'financialAuditAgree'
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/clearOperateProgress`,
				data: params
			}).then(res => {
			})
		},
		check () {
			let params = {
				operate: 'financialAuditAgree'
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/batchOperateProgress`,
				data: params
			}).then(res => {
				this.percentage = res.data.prograss
				if (this.percentage === 100) {
					this.clearTimer()
					if (res.result === true) {
						clearInterval(this.timer)
						this.timer = null
						this.$message.success(res.msg)
						let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
						let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
						// tabParams.orderStatus = res.data
						window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
						window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
						this.getDetail(orderParams, tabParams)
					} else {
						this.$message.error(res.msg)
					}
				}
			})
		},

		financialAuditeHandler (type) {
			if (type === 'resolve') {
				this.rejectFinancialAuditeFlag = false
			} else {
				this.rejectFinancialAuditeFlag = true
			}
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let params = {
				orderid: orderParams.orderId,
				rejectFinancialAuditeFlag: this.rejectFinancialAuditeFlag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/financialAudite`,
				data: [params]
			}).then(res => {
				if (res.result) {
					this.loop()
				} else {
					let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
					this.$message.error(resMsg)
				}
			}).catch(() => {
				this.$message.error('订单状态已改变!')
			})
		},
		cancelOrder (val) {
			if (val === '财务审核') {
				this.cancelArr = this.cancelArr
				this.cancelValue = 11
			} else if (val === '待发货') {
				this.cancelArr = this.cancelArr2
				this.cancelValue = 16
			}
			this.cancelDialogVisible = true
		},
		cancelValueSelect (e, val) {
			console.log(e)
			if (val === '财务审核') {
				if (e !== 15) {
					this.cancelcauser = ''
					this.causerSize = 0
				}
			} else if (val === '待发货') {
				if (e !== 19) {
					this.cancelcauser = ''
					this.causerSize = 0
				}
			}
		},
		closeCancelDialog () {
			this.cancelDialogVisible = false
			this.cancelcauser = ''
			this.causerSize = 0
			// this.cancelValue = 11
		},
		financialAuditeCancel () {
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
			let params = {
				orderid: orderParams.orderId,
				statusid: orderParams.statusId,
				buyerSellerType: '1',
				cancelcause: this.cancelValue,
				othercauser: this.cancelcauser,
				orderstatus: tabParams.orderStatus,
				operateCode: 2010
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/cancel`,
				data: params
			}).then(res => {
				if (res.result) {
					this.cancelDialogVisible = false
					this.cancelcauser = ''
					this.causerSize = 0
					// this.cancelValue = 11
					this.$message.success('取消成功！')
					this.getDetail(orderParams, tabParams)
				} else {
					let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
					this.$message.error(resMsg)
				}
			}).catch(() => {
				this.$message.error('订单状态已改变!')
			})
		},
		lockOrder (type) {
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
			let detailData = JSON.parse(this.detailData)
			console.log(detailData)
			let ordernumber = detailData.orderNumber
			let params = [{
				orderid: orderParams.orderId,
				action: 2,
				orderstatus: 1,
				statusid: orderParams.statusId,
				ordernumber
			}]
			console.log(params)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order${type}`,
				data: params
			}).then(res => {
				if (res.result) {
					if (type === '/lock') {
						this.$message.success('锁定成功！')
					} else {
						this.$message.success('解锁成功！')
					}
					this.getDetail(orderParams, tabParams)
				} else {
					let resMsg = res.msg
					this.$message.error(resMsg)
				}
			}).catch((err) => {
				this.$message.error(err.msg)
			})
		},
		liquidate (type) {
			let params = {
				liquidateflag: type,
				orderids: this.orderid
			}
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/liquidateflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getDetail(orderParams, tabParams)
				} else {
					this.$message.error('勾销失败，请稍后重试')
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-detail-body {
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-detail-header {
		// height:50px;
		// line-height:50px;
		// text-align:left
		// font-size: 16px;
		// border-bottom 1px solid #DCE1FE
		font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
		.my-position {
			font-size: 14px;
			display: inline-block;
			position: relative;
			top: -20px;
		}
		.position {
			width: 15px;
			height: 15px;
			float: left;
			margin: 17px 11px 0 9px;
		}
		.el-breadcrumb {
			display inline-block
			height: 49px
			line-height: 49px
			.go-back-span {
				font-weight: 700
				cursor: pointer
			}
		}
		img {
			height: 40px
			float: right
			margin-top: 4px
			margin-right: 20px
		}
	}
	.order-detail-info {
		display flex;
		flex: 1;
		box-sizing :border-box;
		height: calc(100% - 110px);
		// padding-top: 10px
		.info-left {
			display flex
			flex: 1
			height: 100%
			flex-direction column
			margin-right: 10px
			overflow: hidden
			.info-left-container {
				display flex
				flex: 1
				flex-direction column
				overflow-y auto
			}
			.info-btn {
				padding: 20px 0
				text-align left
				.btn {
					width :120px;
					height :35px;
					margin-left :20px;
				}
				.printcount {
					color: #4091ff;
					font-size: 12px;
					padding: 5px;
					display: inline-block;
				}
			}
		}
		.info-right {
			display flex
			overflow-y :auto
			box-sizing: border-box
			width: 300px
		}
	}
	.add-goods-content {
		min-height: 200px;
		padding-bottom: 20px;
		.add-goods-select-box {
			display: flex;
			span {
				padding-right: 8px;
				line-height: 28px;
			}
			.el-select {
				flex: 1;
			}
		}
		.add-goods-item {
			display: flex;
			margin: 10px 0;
			& > span {
				width: 84px;
				padding-right: 8px;
				line-height: 28px;
				text-align: right;
			}
			.minbuycnt-tips {
				margin-left: 8px;
				color: red;
			}
			.goods-info-box {
				flex: 1;
				display: flex;
				padding: 8px 12px;
				background: #FBFBFF;
				border-radius: 4px;
				border: 1px solid #F4F4F5;
				img {
					width: 100px;
					height: 100px;
					border-radius: 12px;
					border: 1px solid #eee;
				}
				& > div {
					padding-left: 6px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					div {
						padding: 8px 0;
					}
				}
			}
			.select-box1 {
				flex: 1;
				min-width: 0;
				align-items :center;
				display :flex;
			}
			.select-box {
				flex: 1;
				min-width: 0;
				span {
					display: inline-block;
					min-width: 70px;
					height: 28px;
					line-height: 26px;
					border-radius: 6px;
					border: 1px solid #d1d5e4;
					color: #999c9a;
					text-align: center;
					margin-right: 12px;
					cursor: pointer;
					box-sizing: border-box;
					padding: 0 4px;
					margin-bottom: 6px;
					&.active {
						background: #F6F8FE;
						color: #62ADFA;
						border-color: #77b9fb;
					}
				}
			}
		}
	}
}
</style>
<style lang="stylus">
.order-detail-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px;
		padding-bottom: 20px;
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.delivery-box {
		display: flex
		align-items: center
		margin-top: 25px;
		.delivery-select {
			width: 150px
		}
	}
	.express-btn {
		text-align: right;
		margin-top: 35px;
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
	.btn-box {
		display flex
		justify-content: center
		.el-button {
			width: 120px
		}
	}
}
.dialog-title2 {
	text-align: left;
	.el-dialog__footer {
		text-align: center
	}
}
.dialog-title3 {
	text-align: left;
	.el-dialog__body {
		padding: 10px 20px;
	}
}
.dialog-no-title{
	.el-dialog__header{
		display: none
	}
	.el-dialog__body{
		padding: 0
	}
}
</style>
